import React from "react";

import { Select } from "@shared/selects";
import { TextInput } from "@shared/text-input";

import {
  type AdvancedBreakdownDescriptor,
  type AdvancedSegmentDescriptor,
  type AdvancedSegmentLevel,
} from "../types";

import { LabelRuleSimulator } from "./label-rule-simulator";
import { MatcherEditor } from "./matcher-editor";
import { OutputValue } from "./output-value";

interface Props {
  breakdown: AdvancedBreakdownDescriptor;
  segment: AdvancedSegmentDescriptor;
  onChange: (value: AdvancedSegmentDescriptor) => void;
}

export const SegmentForm = ({ breakdown, segment, onChange }: Props) => {
  return (
    <>
      <div className="mb-3">
        <h4 className="m-0 text-xl font-bold">Details</h4>
        <p className="text-sm text-gray+1 m-0">
          Rank represents the order in which the rules will execute and assign
          labels. Lower number rules will execute first.
        </p>
        <div className="w-[260px] text-sm mt-3">
          <TextInput
            label="RULE NAME"
            value={segment.name}
            onChange={(e) => onChange({ ...segment, name: e.target.value })}
          />
          {segment.errors.name && (
            <div className="text-xxs text-mars mt-1">
              *{segment.errors.name}
            </div>
          )}
          <TextInput
            className="mt-4"
            label="RANK"
            value={segment.priority.toString()}
            onChange={(e) =>
              onChange({
                ...segment,
                priority: e.target.value,
              })
            }
            onBlur={() => {
              onChange({
                ...segment,
                priority: parseInt(segment.priority.toString()),
              });
            }}
          />
          {segment.errors.priority && (
            <div className="text-xxs text-mars mt-1">
              *{segment.errors.priority}
            </div>
          )}
          <div className="mt-4">
            <Select<AdvancedSegmentLevel>
              label="LEVEL"
              options={[
                { label: "Campaign", value: "campaign" },
                { label: "Adset", value: "adset" },
                { label: "Ad", value: "ad" },
              ]}
              value={segment.level}
              onChange={(value) => onChange({ ...segment, level: value })}
            />
          </div>
          {segment.errors.level && (
            <div className="text-xxs text-mars mt-1">
              *{segment.errors.level}
            </div>
          )}
        </div>
      </div>
      <div className="mt-8">
        <MatcherEditor
          matcher={segment.matcher}
          error={segment.errors.matcher}
          onChange={(value) => onChange({ ...segment, matcher: value })}
        />
      </div>
      <div className="mt-8">
        <OutputValue
          output={segment.output}
          matcher={segment.matcher}
          error={segment.errors.output}
          onChange={(value) => onChange({ ...segment, output: value })}
        />
      </div>
      <div className="mt-8">
        <LabelRuleSimulator segments={breakdown.segments} segment={segment} />
      </div>
    </>
  );
};
